import { HTMLProps, useContext } from 'react';
import { usePostDialogueData } from '../../../../api/pension-robot/usePostPensionDialogueData';
import { RobotEnvironmentContext } from '../../../../contexts/general/RobotEnvironmentContext';
import { PensionContext } from '../../../../contexts/pension-robot/PensionContext';
import { isMyBND } from '../../../../utils/functions';
import { CurrencyFormGroup } from '../../../general/form-inputs/CurrencyFormGroup';

export const ChangeExpenses: React.FC<{} & HTMLProps<HTMLDivElement>> = () => {
    const {
        parameters: { expensesInfo },
        actions,
    } = useContext(PensionContext);

    const { environment } = useContext(RobotEnvironmentContext);
    const usePostDialogueDataQuery = usePostDialogueData();

    return (
        <div className="p-4 pb-8 border-b">
            <div className="mb-2">
                Verwacht u later niet genoeg inkomen te hebben om uw uitgaven te bekostigen? Dan kunt u ook een
                aanpassing doen in uw uitgaven.
            </div>
            <CurrencyFormGroup
                value={expensesInfo?.goal}
                className="w-full"
                onChange={(cents) => {
                    actions.setParameters({ expensesInfo: { goal: cents } });
                    isMyBND(environment) && usePostDialogueDataQuery.refetch();
                }}
            />
        </div>
    );
};
